<nuc-empty-state-component imageUrl="assets/images/empty_states/no_permission_small.svg"
                           small="true"
                           title="You or your team does not have permissions to view this section. Contact the team owner to enable this section.">
</nuc-empty-state-component>
